import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

import { getComponents, allowedElements } from './utils';

import { MarkdownContentProps, ContentType } from './types';

const MarkdownContent: React.FC<MarkdownContentProps> = ({
  content,
  contentType = ContentType.PRIMARY,
  ...rest
}) => {
  const components = getComponents(contentType);

  return (
    <ReactMarkdown
      data-testid="markdown"
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      allowedElements={allowedElements}
      components={components}
      {...rest}
    >
      {content}
    </ReactMarkdown>
  );
};

export default MarkdownContent;
